// export const STATIC_HOST = 'http://universad.lc/upload/';
// export const API_HOST = 'http://universad.lc/api/v1';

export const STATIC_HOST = 'https://universad.ru/upload/';
export const API_HOST = 'https://universad.ru/api/v1';
